﻿/**
 * Finds the first ancestor element (or the element itself) that matches the specified CSS selector.
 * @param element The starting element to search from.
 * @param selector The CSS selector to match against.
 * @returns The matching HTMLElement or undefined if no match is found.
 */
export function parentElement(element: HTMLElement | undefined, selector: string): HTMLElement | undefined {
	let current: HTMLElement | undefined | null = element;

	while (current) {
		if (current.matches(selector)) {
			return current;
		}
		current = current.parentElement;
	}

	return undefined;
}
